<template>
  <div class="middle-box text-center animated fadeInDown">
        <h1>403</h1>
        <h3 class="font-bold">Access restricted</h3>

        <div class="error-desc">
          Sorry, but the page you are looking for is restricted. Please ensure you have enough righs or contact your administrator.
        </div>
    </div>

</template>

<script lang="ts">
import Vue from '@fwk-node-modules/vue';
import { Component } from '@fwk-node-modules/vue-property-decorator';
import { mixins } from '@fwk-node-modules/vue-class-component';
import GenericPage from '@fwk-client/components/mixins/GenericPage.vue';

@Component({})
export default class AccessRestricted extends mixins(GenericPage) {
 
}
</script>